import rootApi from '@utils/baseAPI/WrapperApi';

// Get all favorite filters for current user
export const apiGetFavoriteFilters = () => {
  return rootApi.get('api/favorite-filters');
};

// Get popular filters (most used)
export const apiGetPopularFilters = (limit = 5) => {
  return rootApi.get('api/favorite-filters/popular', { params: { limit } });
};

// Get specific favorite filter by ID
export const apiGetFavoriteFilterById = (id) => {
  return rootApi.get(`api/favorite-filters/${id}`);
};

// Create new favorite filter
export const apiCreateFavoriteFilter = (data) => {
  return rootApi.post('api/favorite-filters', data);
};

// Update favorite filter
export const apiUpdateFavoriteFilter = (id, data) => {
  return rootApi.put(`api/favorite-filters/${id}`, data);
};

// Delete favorite filter
export const apiDeleteFavoriteFilter = (id) => {
  return rootApi.delete(`api/favorite-filters/${id}`);
};

// Toggle favorite status
export const apiToggleFavoriteFavoriteFilter = (id) => {
  return rootApi.patch(`api/favorite-filters/${id}/toggle-favorite`);
};

// Apply filter and increment usage count
export const apiApplyFavoriteFilter = (id) => {
  return rootApi.get(`api/favorite-filters/${id}/apply`);
};

// Export current filter items into Excel (filled import template)
export const apiExportFavoriteFilterItems = (id) => {
  return rootApi.get(`api/favorite-filters/${id}/export-items`, { responseType: 'blob' });
};

// Download Excel template for importing favorite filter items
export const apiDownloadFavoriteFilterTemplate = () => {
  return rootApi.get('api/favorite-filters/export-template', { responseType: 'blob' });
};

// Import favorite filter items from Excel
export const apiImportFavoriteFilter = (formData) => {
  return rootApi.post('api/favorite-filters/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    responseType: 'blob'
  });
};
